const modalSupportTextField = {
  label: 'Description'
};

export default modalSupportTextField;
